<template>
  <b-modal
      id="modal-edit"
      title="ویرایش متادیتا"
      hide-footer
      header-bg-variant="light"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="عنوان" label-for="editTitle">
        <b-form-input id="editTitle" v-model="form.title" />
      </b-form-group>
      <b-form-group label="متن جایگزین (Alt)" label-for="editAlt">
        <b-form-input id="editAlt" v-model="form.alt" />
      </b-form-group>
      <b-form-group label="توضیحات" label-for="editDesc">
        <b-form-textarea id="editDesc" v-model="form.description" rows="3" />
      </b-form-group>
      <b-form-group label="برچسب‌ها (با کاما جدا کنید)" label-for="editTags">
        <b-form-input id="editTags" v-model="form.tags" placeholder="مثلاً: طبیعت, شهری" />
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" type="submit">ذخیره</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton } from 'bootstrap-vue'

export default {
  name: 'EditMetadataModal',
  components: { BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BButton },
  props: {
    file: { type: Object, default: null } // can be null if initial data passed separately
  },
  data() {
    return {
      form: { title: '', alt: '', description: '', tags: '' }
    }
  },
  watch: {
    file: {
      immediate: true,
      handler(newFile) {
        if (newFile) {
          this.form.title = newFile.title || ''
          this.form.alt = newFile.alt || ''
          this.form.description = newFile.description || ''
          this.form.tags = newFile.tags || ''
        }
      }
    }
  },
  methods: {
    submit() {
      this.$emit('save', { ...this.form })
    }
  }
}
</script>
